<template>
    <div class="container">
        <loader :active="loading"/>

        <header class="jumbotron">
            <div class="info">
                <div class="info-head">
                    <font-awesome-icon icon="hand-point-right"/>
                    <h3>Ustawienia premium zaczepek</h3></div>
                    <small>Poniżej możesz ustawić kanały takie jak np. rekrutacja.</small><br>
                    <small>Po wejściu użytkownika na taki kanał, odpowienie grupy kanałowe zostaną o tym powiadomione.</small><br>
                    <small>Jeśli chcesz zedytować kanał utwórz nową regułę na ten sam kanał.</small>
            </div>

            <refresh :func="refresh"/>
        </header>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <form name="form" @submit.prevent="addChannel">
                        <div class="card-header">
                            <h5> Ustawienia </h5>
                        </div>

                        <div class="card-body text-center">
                            <v-client-table :columns="columns" :data="channels" :options="options">
                                <div slot="options" slot-scope="props">
                                    <button class="btn btn-danger" @click.prevent="delChannel(props.row.channel.cid)">
                                        Usuń
                                    </button>
                                </div>
                                <div slot="channelGroups" slot-scope="props">
                                    <ul>
                                        <li v-for="channelGroup in props.row.channelGroups" :key="channelGroup.id">
                                            {{ channelGroup.name }}
                                        </li>
                                    </ul>
                                </div>
                                <ul slot="channel" slot-scope="props" class="ts-channel">
                                    <channel :channel="props.row.channel" :clickable="false"/>
                                </ul>
                              <div slot="type" slot-scope="props">
                                <span v-if="props.row.type === 'priv'">Wiadomość prywatna</span>
                                <span v-else>Poke</span>
                              </div>
                            </v-client-table>
                        </div>

                        <div class="card-footer">
                            <button :disabled="loading" class="btn btn-success">
                                <span><font-awesome-icon icon="plus"/> Dodaj nowy kanał</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PremiumPokesService from '../services/premiumPokes.service';
import Vue from "vue";
import SelectChannels from "../components/SelectChannels";
import SelectChannelGroups from "../components/SelectChannelGroups";

export default {
    name: 'PremiumPokes',
    data() {
        return {
            loading: true,
            channels: [],
            columns: ['channel', 'channelGroups', 'msgContent', 'pokeContent', 'type', 'options'],
            options: {
                headings: {
                    channel: 'Kanał',
                    channelGroups: 'Grupy kanałowe',
                    msgContent: 'Wiadomość do użytkownika (Priv)',
                    pokeContent: 'Wiadomość do admina (Poke)',
                    type: 'Typ wiadomości do admina',
                    options: 'Opcje',
                },
                filterable: ['client', 'channelGroups'],
                sortable: [],
                texts: window.vueTableLocalize,
            },
        };
    },
    mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.loading = true;

            PremiumPokesService.getSettings().then(
                response => {
                    this.channels = response.data.channels;
                    this.loading = false;
                },
                error => {
                    this.loading = false;
                    console.log(error)
                }
            );
        },
        async addChannel() {
            this.loading = true;

            PremiumPokesService.getAllChannels().then(
                async (response) => {
                    let channels = response.data.allChannels;
                    let ComponentClass = Vue.extend(SelectChannels);

                    let vueFormInstance = new ComponentClass({
                        propsData: {channels: channels, onlyOne: true, allChecked: false}
                    });

                    let {value} = await Vue.swal.fire({
                        title: '1. Wybierz kanał',
                        html: '<div id="channels"></div>',
                        showCancelButton: true,
                        confirmButtonText: 'Ok',
                        cancelButtonText: 'Anuluj',
                        showLoaderOnConfirm: true,
                        onBeforeOpen: () => {
                            vueFormInstance.$mount();
                            document.getElementById("channels").appendChild(vueFormInstance.$el);
                        },
                        preConfirm: () => {
                            let result = vueFormInstance.getResults();
                            vueFormInstance.$destroy();
                            vueFormInstance = null;
                            return result;
                        }
                    });

                    if (value) {
                        let channelId = value;
                        PremiumPokesService.getAllChannelGroups().then(
                            async (response) => {
                                let channelGroups = response.data.allChannelGroups;
                                let ComponentClass = Vue.extend(SelectChannelGroups);
                                let vueFormInstance = new ComponentClass({
                                    propsData: {channelGroups: channelGroups, onlyOne: false, allChecked: false}
                                });

                                let result = await Vue.swal.fire({
                                    title: '2. Wybierz grupy kanałowe',
                                    html: '<div id="channel-groups"></div>',
                                    showCancelButton: true,
                                    confirmButtonText: 'Ok',
                                    cancelButtonText: 'Anuluj',
                                    showLoaderOnConfirm: true,
                                    onBeforeOpen: () => {
                                        vueFormInstance.$mount();
                                        document.getElementById("channel-groups").appendChild(vueFormInstance.$el);
                                    },
                                    preConfirm: () => {
                                        let result = vueFormInstance.getResults();
                                        vueFormInstance.$destroy();
                                        vueFormInstance = null;
                                        return result;
                                    }
                                });

                                if (result.value) {
                                    let channelGroups = result.value;

                                    let {value} = await Vue.swal.fire({
                                        title: '3. Wpisz komunikaty',
                                        html: '<div id="inputs"><label>Wiadomość wysyłana do lidera</label><br><textarea id="poke"></textarea><br><input id="type" type="checkbox"/><label for="type" style="margin-left: 5px;">Wiadomość prywatna (nie poke)</label><hr><label>Wiadomość wysyłana do użytkownika</label><br><textarea id="msg"></textarea></div>',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Anuluj',
                                        showLoaderOnConfirm: true,
                                        preConfirm: () => {
                                            return {
                                                msg: document.getElementById('msg').value,
                                                poke: document.getElementById('poke').value,
                                                type: document.getElementById('type').checked ? 'priv' : 'poke'
                                            }
                                        }
                                    });

                                    if (value) {
                                        this.loading = false;

                                        PremiumPokesService.addChannel(channelId, channelGroups, value.msg, value.poke, value.type).then(
                                            () => {
                                              this.loading = true;
                                              this.refresh();

                                              Vue.swal.fire({
                                                title: 'Dodano nowy kanał!',
                                                icon: 'success',
                                                timer: 1000,
                                                showConfirmButton: false,
                                              });
                                            },
                                            error => {
                                              this.loading = false;
                                              console.log(error);
                                            }
                                        );
                                    } else
                                        this.loading = false;
                                } else
                                    this.loading = false;
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    } else
                        this.loading = false;
                },
                error => {
                    this.loading = false;
                    console.log(error)
                }
            );
        },
        delChannel(cid) {
            Vue.swal.fire({
                title: 'Jesteś pewny?',
                text: "Nie będziesz mógł cofnąć tej operacji!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Tak, usuń!',
                cancelButtonText: 'Anuluj'
            }).then((result) => {
                if (result.value) {
                    this.loading = true;

                    PremiumPokesService.delChannel(cid).then(
                        () => {
                            this.refresh();

                            Vue.swal.fire({
                                title: 'Usunięto!',
                                icon: 'success',
                                timer: 1000,
                                showConfirmButton: false,
                            });
                        },
                        error => {
                            this.loading = false;
                            console.log(error)
                        }
                    );
                }
            });
        }
    }
};
</script>

<style>
.ts-channel {
    list-style: none;
    padding-inline-start: 0;
}
</style>
